export const CONTROL_CARD_APPLICATION_REASON_ROUTE = 'powod-skladania-wniosku';
